var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"hidden","name":_vm.filtername},domProps:{"value":_vm.selectedSpecificationPropertyMasterDataId}}),_vm._v(" "),_c('v-select',{attrs:{"options":_vm.selections,"label":"title"},on:{"input":_vm.setSelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }